import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/modello_camicia/tasche_western.gltf')

  const { tasche, chiusura, pattina, tessuto, bottoni, fili, matBottone, bottone } = props;

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.tasca_sinistra.geometry}
        material={nodes.tasca_sinistra.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial
          map={tessuto}
          roughness={1}
          toneMapped={false}
          side={2}
        />
      </mesh>
      {tasche === 2 &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.tasca_destra.geometry}
          material={nodes.tasca_destra.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshStandardMaterial
            map={tessuto}
            roughness={1}
            toneMapped={false}
            side={2}
          />
        </mesh>
      }
      {tasche === 2 && pattina === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.pattina_destra.geometry}
          material={nodes.pattina_destra.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshStandardMaterial
            map={tessuto}
            roughness={1}
            toneMapped={false}
            side={2}
          />
        </mesh>
      }
      {pattina === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.pattina_sinistra.geometry}
          material={nodes.pattina_sinistra.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshStandardMaterial
            map={tessuto}
            roughness={1}
            toneMapped={false}
            side={2}
          />
        </mesh>
      }
      {chiusura === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bottone_sinistro.geometry}
          material={nodes.bottone_sinistro.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={bottoni}
            map={bottone}
          />
        </mesh>
      }
      {chiusura === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.fili_sinistro.geometry}
          material={nodes.fili_sinistro.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshStandardMaterial color={fili} />
        </mesh>
      }
      {tasche === 2 && chiusura === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bottone_destro.geometry}
          material={nodes.bottone_destro.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={bottoni}
            map={bottone}
          />
        </mesh>
      }
      {tasche === 2 && chiusura === true &&
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.fili_destro.geometry}
          material={nodes.fili_destro.material}
          position={[0.03, 0.03, 0.01]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.08, 0.08, 0.08]}
        >
          <meshStandardMaterial color={fili} />
        </mesh>
      }
    </group>
  )
}

useGLTF.preload('/modello_camicia/tasche_western.gltf')